<template>
  <div class="order-list-wrapper">
    <div class="order-list-header">
      <van-nav-bar title="订单列表" />
      <div class="order-list-filter">
        <div class="dropdown-row">
          <div class="dropdown-item-like" @click="showArea = true">
            <span :class="{ 'dropdown-placeholder': !regionText }">
              {{ regionText || '选择地区' }}
            </span>
          </div>
          <van-dropdown-menu active-color="#1989fa" style="flex: 1;">
            <van-dropdown-item v-model="filter.subject" :options="subjectOptions" placeholder="辅导科目" @change="onSubjectChange" />
            <van-dropdown-item v-model="filter.grade" :options="gradeOptions" placeholder="辅导年级" @change="onGradeChange" />
          </van-dropdown-menu>
        </div>
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            :value="areaValue"
            @confirm="onAreaConfirm"
            @cancel="showArea = false"
          />
        </van-popup>
      </div>
    </div>
    <div class="order-list-content scrollable-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div>
          <div
            v-for="item in list"
            :key="item.id"
            class="order-card"
            @click="showDetail(item)"
          >
            <div class="order-card-title">{{ item.subject }}</div>
            <div class="order-card-desc">地区：{{ item.city }}/{{ item.address }}</div>
            <div class="order-card-desc">授课时间：{{ item.time_plan }}</div>
            <div class="order-card-price">
              课酬：<span class="price">￥{{ item.teacher_salary_text }}</span>
            </div>
            <div class="order-card-actions">
              <van-button size="small" type="primary" class="contact-btn" @click.stop="showContactPopup(item)">联系方式</van-button>
              <van-button size="small" class="copy-btn" @click.stop="copyInfo(item)">复制信息</van-button>
            </div>
          </div>
          <van-empty
            v-if="!list.length && !loading && !refreshing"
            description="暂无订单"
            image="default"
          />
        </div>
      </van-pull-refresh>
      <!-- 订单详情弹窗 居中显示 -->
      <van-popup v-model="showPopup" round position="center" :style="{ width: '90%', maxWidth: '420px', padding: '0' }">
        <div class="order-detail-popup">
          <div class="popup-header">
            <span class="popup-no">编号：{{ detail.no }}</span>
            <van-icon name="close" class="popup-close" @click="showPopup = false" />
          </div>
          <div class="popup-row"><b>城市：</b><span class="popup-row-content">{{ detail.city }}</span></div>
          <div class="popup-row"><b>详细地址：</b><span class="popup-row-content">{{ detail.address }}</span></div>
          <div class="popup-row"><b>辅导科目：</b><span class="popup-row-content">{{ detail.subject }}</span></div>
          <div class="popup-row"><b>学员年级：</b><span class="popup-row-content">{{ detail.grade }}</span></div>
          <div class="popup-row"><b>时间安排：</b><span class="popup-row-content">{{ detail.time_plan }}</span></div>
          <div class="popup-row"><b>老师酬劳：</b><span class="popup-row-content"><span class="popup-price">{{ detail.teacher_salary_text }}</span></span></div>
          <div class="popup-row"><b>学员情况：</b><span class="popup-row-content">{{ detail.stu_desc }}</span></div>
          <div class="popup-row"><b>要求：</b><span class="popup-row-content">{{ detail.teacher_demand }}</span></div>
          <div class="popup-actions">
            <van-button size="small" type="primary" class="contact-btn">联系方式</van-button>
            <van-button size="small" class="copy-btn" @click="copyInfo(detail)">复制信息</van-button>
          </div>
        </div>
      </van-popup>
    </div>
    <van-popup v-model="showContact" position="bottom" :closeable="true">
      <div class="contact-popup">
        <div class="contact-qr-wrapper">
          <img
            v-if="!contactImgEmpty"
            :src="contactImgUrl"
            class="contact-qr"
            :class="{ 'qr-swing': showContact }"
            @click="enlargeQr(contactImgUrl)"
          />
          <div v-else class="no-contact-img">当前未设置联系方式</div>
        </div>
        <div class="contact-tip">截图，微信识别二维码可添加客服微信</div>
      </div>
      <van-image-preview v-model="showQrPreview" :images="qrPreviewList" v-if="showQrPreview" />
    </van-popup>
  </div>
</template>

<script>
import { getSubjects, getGradeList, getOrderList } from '@/api/tutoringAgency';
import { areaList } from '@vant/area-data';
export default {
  name: 'OrderList',
  props: {
    orgId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      filter: {
        subject: '',
        grade: '',
        region: '江苏省/南京市',
      },
      subjectOptions: [],
      gradeOptions: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 10,
      showPopup: false,
      detail: {},
      showArea: false,
      areaList,
      areaValue: '320100', // 默认南京市code，江苏省自动选中
      regionText: '江苏省/南京市',
      showContact: false,
      contactInfo: '',
      showQrPreview: false,
      qrPreviewList: [],
      contactImgUrl: '', // 新增
      contactImgEmpty: false, // 新增
    }
  },
  mounted() {
    this.loadSubjectsAndGrades();
    this.fetchOrderList();
  },
  methods: {
    async loadSubjectsAndGrades() {
      // 处理科目
      try {
        const res = await getSubjects();
        this.subjectOptions = [
          { text: '选择科目', value: '' },
          ...((res.data || []).map(item => ({ text: item, value: item })))
        ];
      } catch (e) {
        this.$toast && this.$toast('获取科目失败');
      }
      // 处理年级
      try {
        const res = await getGradeList();
        this.gradeOptions = [
          { text: '选择年级', value: '' },
          ...((res.data || []).map(item => ({ text: item, value: item })))
        ];
      } catch (e) {
        this.$toast && this.$toast('获取年级失败');
      }
    },
    async fetchOrderList() {
      if (!this.orgId) return;
      this.loading = true;
      try {
        const params = {
          city: this.regionText,
          subject: this.filter.subject,
          grade: this.filter.grade
        };
        const res = await getOrderList(this.orgId, params);
        this.list = res.data || [];
        // 关键：如果没有数据，设置finished为true，阻止继续加载
        this.finished = !this.list.length;
      } catch (e) {
        this.$toast && this.$toast('获取订单失败');
        this.finished = true;
      }
      this.loading = false;
      this.refreshing = false;
    },
    // 在筛选条件变化时调用fetchOrderList
    onAreaConfirm(values) {
      const regionStr = values.map(item => item.name).join('/');
      this.regionText = regionStr;
      this.filter.region = regionStr;
      this.areaValue = values[values.length - 1].code;
      this.showArea = false;
      this.fetchOrderList();
    },
    // subject/grade筛选变化时也调用fetchOrderList
    async onSubjectChange() {
      await this.fetchOrderList();
    },
    async onGradeChange() {
      await this.fetchOrderList();
    },
    onRefresh() {
      this.finished = false;
      this.page = 1;
      this.fetchOrderList();
    },
    copyInfo(item) {
      const info = `#${item.city}
【${item.city} ${item.grade} ${item.subject}】
🈶ll${item.id}
【时间】：${item.time_plan}
【地点】：${item.city} ${item.address}
【年级】：${item.grade}
【科目】：${item.subject}
【学员情况】：${item.sex}； ${item.stu_desc}
【要求】：${item.teacher_demand}
【薪资】：${item.teacher_salary_text}`;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(info)
        this.$toast.success('已复制')
      } else {
        this.$toast('请手动复制')
      }
    },
    showDetail(item) {
      this.detail = { ...item }
      this.showPopup = true
    },
    showContactPopup(item) {
      if (item && item.wx_contact_img) {
        let base = process.env.VUE_APP_BASE_API;
        if (base.endsWith('/api')) {
          base = base.slice(0, -4);
        }
        console.log("base", base);
        this.contactImgUrl = base + item.wx_contact_img;
        this.contactImgEmpty = false;
      } else {
        this.contactImgUrl = '';
        this.contactImgEmpty = true;
      }
      this.showContact = true;
    },
    enlargeQr(url) {
      this.qrPreviewList = [url];
      this.showQrPreview = true;
    },
  }
}
</script>

<style scoped>
.order-list-wrapper {
  min-height: 100vh;
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.order-list-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #f7f8fa;
}
.order-list-content.scrollable-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px 16px 0 16px;
}
.order-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  margin-bottom: 12px;
  padding: 14px 14px 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
}
.order-card-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 2px;
  color: #222;
  text-align: left;
}
.order-card-desc {
  color: #444;
  font-size: 14px;
  text-align: left;
  margin-bottom: 0;
}
.order-card-price {
  margin: 4px 0 8px 0;
  font-size: 15px;
  color: #333;
  text-align: left;
}
.order-card-price .price {
  color: #e53935;
  font-weight: bold;
  font-size: 15px;
}
.order-card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}
.contact-btn {
  background: linear-gradient(90deg, #1989fa 0%, #4fc3f7 100%);
  border: none;
  color: #fff;
  padding: 0 12px;
}
.copy-btn {
  background: #fff;
  color: #1989fa;
  border: 1px solid #1989fa;
  padding: 0 12px;
}
.empty-tip {
  text-align: center;
  color: #bbb;
  margin-top: 40px;
  font-size: 16px;
}
.order-detail-popup {
  background: #fff;
  border-radius: 12px;
  padding: 18px 0 12px 0;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  font-size: 15px;
  color: #222;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
}
.popup-padding {
  padding-left: 16px;
  padding-right: 16px;
}
.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  border-bottom: 2px solid #F2F3F5;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 10px;
}
.popup-title {
  font-weight: bold;
  font-size: 17px;
  color: #222;
}
.popup-no {
  font-size: 13px;
  color: #888;
  /* margin-left: 8px; */
}
.popup-close {
  font-size: 20px;
  color: #888;
  cursor: pointer;
  margin-left: 8px;
}
.popup-row {
  display: flex;
  align-items: flex-start;
  padding: 0 15px;
  margin-bottom: 6px;
  color: #333;
  font-size: 15px;
  word-break: break-all;
}
.popup-row b {
  display: inline-block;
  min-width: 80px;
  font-weight: bold;
  color: #222;
  flex-shrink: 0;
  text-align: right;
}
.popup-row-content {
  flex: 1;
  text-align: left;
  word-break: break-all;
  white-space: pre-line;
}
.popup-price {
  color: #e53935;
  font-weight: bold;
}
.popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 30px;
  padding: 12px 15px 0 15px;
  border-top: 2px solid #F2F3F5;
}
/* 让自定义地区选择和van-dropdown-item风格统一 */
.dropdown-row {
  display: flex;
  align-items: stretch;
  margin-bottom: 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  padding: 0 4px;
  min-height: 44px;
}
.dropdown-item-like {
  display: flex;
  align-items: center;
  background: transparent;
  border-radius: 8px;
  padding: 0 16px;
  color: #323233;
  font-size: 15px;
  cursor: pointer;
  position: relative;
  transition: background 0.2s;
}
.dropdown-item-like:hover {
  background: #f7f8fa;
}
.dropdown-placeholder {
  color: #323233;
}
.dropdown-item-like::after {
  position: absolute;
  top: 50%;
  right: 4px;
  margin-top: -5px;
  border: 3px solid;
  border-color: transparent transparent #dcdee0 #dcdee0;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  opacity: .8;
  content: '';
}
/* 彻底移除van-dropdown-menu__bar的box-shadow，兼容scoped */
::v-deep .van-dropdown-menu__bar {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
/* 联系方式弹窗样式 */
.contact-popup {
  padding: 40px 24px 24px 24px;
  text-align: center;
  min-height: 340px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.phone-bold {
  font-weight: bold;
  font-size: 18px;
  color: #222;
}
.contact-qr-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}
.contact-qr {
  width: 200px;
  height: 200px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  background: #fff;
  object-fit: contain;
  cursor: pointer;
}
.contact-tip {
  color: #bbb;
  font-size: 13px;
  margin-top: 8px;
}
.qr-swing {
  animation: qrSwing 0.7s cubic-bezier(.36,.07,.19,.97) both;
}
@keyframes qrSwing {
  0% { transform: rotate(0deg); }
  15% { transform: rotate(-10deg); }
  30% { transform: rotate(8deg); }
  45% { transform: rotate(-6deg); }
  60% { transform: rotate(4deg); }
  75% { transform: rotate(-2deg); }
  100% { transform: rotate(0deg); }
}
.no-contact-img {
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f5f5f5;
  color: #bbb;
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin: 0 auto;
}
</style> 